import React from "react";
import { CardBody, Container } from "reactstrap";
import PageTitle from "@components/Common/PageTitle";
import unauthorizedaccess from "@assets/images/unauthorizedaccess.png";

export default function Unauthorizedaccess() {
     return (
        <React.Fragment>
            <PageTitle title="TYPE GESTIONNAIRE DE COMPTES" />
            <div className="">
                <Container fluid style={{ marginTop: "-15px" }}>
                    <CardBody
                        className="d-flex justify-content-center"
                        style={{
                            marginTop: "220px",
                        }}
                    >
                        <div className="d-flex flex-column">
                            <div className="p-2">
                                <img
                                    src={unauthorizedaccess}
                                    id=""
                                    data-bs-toggle="dropdown"
                                    aria-expanded="false"
                                    alt=""
                                />
                            </div>
                            <div
                                className="p-2 ml-3"
                                style={{
                                    color: "rgb(36 34 34 / 85%)",
                                    fontWeight: 500,
                                    fontSize: "25px",
                                    width: "fit-content",
                                    fontFamily: "Segoe UI",
                                }}
                            >
                                Accès non autorisé
                            </div>
                        </div>
                    </CardBody>
                </Container>
            </div>
        </React.Fragment>
    );
}
